import axios from 'axios';

export default {
  namespaced: true,

  state: {
    items: [],
  },

  getters: {
    get: (state) => {
      return state.items;
    },
  },

  mutations: {
    set: (state, payload) => {
      state.items = payload;
    },
  },

  actions: {
    fetchCommon({commit}) {
      const params = {
        id: process.env.VUE_APP_COMMON_BRAND_IDS,
        limit: 6,
      };

      commit('set', []);

      return axios.get('/api/brands', {params})
        .then(response => {
          commit('set', response.data);
        });
    },

    search({commit}, queries) {
      const params = {
        ...queries,
        limit: 6,
      };

      commit('set', []);

      return axios.get('/api/brands', {params})
        .then(response => {
          commit('set', response.data);
        });
    },
  },
};
